import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section className="py-10 md:py-24 bg-[#D4A5A5] relative overflow-hidden" data-id="element-87">
      <div className="absolute inset-0 bg-[#3D2B1F] opacity-10 pattern-dots" data-id="element-88"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#FAF7F4] rounded-[2rem] p-6 md:p-16 shadow-2xl" data-id="element-90">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3D2B1F] mb-4" data-id="element-91">
            Empezá a tejer hoy mismo
          </h2>
          <p className="text-base md:text-xl text-[#6B5A4E] mb-6 max-w-2xl mx-auto" data-id="element-92">
            Accedé hoy a la Biblioteca Total de Crochet 2026, con un 50%
            descuento por tiempo limitado
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-93">
            <div className="text-center" data-id="element-94">
              <span className="text-sm text-[#8B7355] uppercase tracking-wider font-bold" data-id="element-95"></span>
              <div className="flex items-center justify-center gap-3" data-id="element-96">
                <span className="text-xl text-[#B8C9C0] line-through font-bold" data-id="element-97">
                  $1197
                </span>
                <span className="text-4xl md:text-5xl font-bold text-[#C17B5C]" data-id="element-98">
                  $597
                </span>
                <span className="text-lg md:text-xl text-[#3D2B1F] font-bold" data-id="element-99">
                  UYU
                </span>
              </div>
            </div>

            <a href="https://factorclaro.com//cart/45275718320307:1" target="_blank" rel="noopener noreferrer" className="w-full max-w-md" data-id="element-100">
              <Button size="md" fullWidth href="https://factorclaro.com//cart/45275718320307:1" target="_blank" rel="noopener noreferrer" className="text-base h-12 shadow-xl shadow-[#C17B5C]/20" data-id="element-101">
                👉 ACCESO CON 50% OFF 👈
              </Button>
            </a>

            <div className="flex items-center gap-2 text-sm text-[#6B5A4E]" data-id="element-102">
              <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-103" />
              <span data-id="element-104">Pago 100% seguro • Entrega inmediata por email</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}